import { Col, Form, Row } from 'antd';
import type { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { ScopeButton } from '../components/buttons';
import { FormInput } from '../components/formInputs';
import { FormSelect } from '../components/formSelect';
import type { SharedUser } from '../users/types';

export type TimezoneOption = { id?: string; name?: string; timezone?: string; label?: string };
export type PhoneCodeOption = { prefix: string; label: string };

type ContactDetailsFormProps = {
  updateContact: (user: Partial<SharedUser>) => void;
  form: FormInstance;
  timezones: TimezoneOption[];
  phoneCodes?: PhoneCodeOption[];
};

export const ContactDetailsForm = ({
  updateContact,
  form,
  timezones,
  phoneCodes = [],
}: ContactDetailsFormProps) => {
  const { t } = useTranslation();
  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={(values) => updateContact(values as Partial<SharedUser>)}
    >
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name="firstName"
            label={t('signup.first-name')}
            rules={[{ required: true, message: t('common.required-field') }]}
          >
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="lastName"
            label={t('signup.last-name')}
            rules={[{ required: true, message: t('common.required-field') }]}
          >
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="companyName" label={t('signup.company-name')}>
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="phonePrefix" label={t('contacts.phone')}>
            <FormSelect
              width="100%"
              showSearch
              options={phoneCodes.map((c) => ({ value: c.prefix, label: c.label }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="phoneNumber" label=" ">
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="website" label={t('common.website')}>
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="email"
            label={t('signup.email-address')}
            rules={[
              { required: true, message: t('common.required-field') },
              { type: 'email', message: t('signup.invalid-email') },
            ]}
          >
            <FormInput width="100%" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="timezone" label={t('common.timezone')}>
            <FormSelect
              width="100%"
              showSearch
              options={timezones.map((tz) => {
                const value = tz.timezone || tz.name || tz.id || '';
                return { value, label: tz.label || tz.name || tz.timezone || tz.id };
              })}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <div className="rows-drawer-footer">
            <ScopeButton type="primary" htmlType="submit" width="100%">
              {t('organisation.save-details')}
            </ScopeButton>
          </div>
        </Col>
      </Row>
    </Form>
  );
};
